import React, { useEffect, useState } from 'react'
import { Form, Row, Col } from 'react-bootstrap'
import styles from '../styles.module.css'
import { useFormik } from 'formik'
import { getOptions, getOrganizationOptions, getCertificationPeriodsOptions } from '../../../utils/getOptions'
import { categories, status_filter } from '../../../assets/const'
import { expertFormValidation } from '../../../assets/validation'
import { useNavigate } from 'react-router-dom'
import Button from '../../../components/Button'
import { useDispatch, useSelector } from 'react-redux'
import { getCurrentPeriod } from '../../../utils/smallHelpers'
import { setReportPeriod } from '../../../actions/reports'

export default function RequestForm({ specializations, organizations, certificationPeriods, getRequestsList, org, fullMode }) {
  
  const dispatch = useDispatch()
  const { form } = useSelector(state => state.expert)
  const [filtersVisible, setFiltersVisible] = useState(false)

  const statuses = fullMode ? status_filter.expert : status_filter.edu_expert

  useEffect(() => {
    if (!form) return;
    getRequestsList(form)
    filters.setValues(form)
  }, [])
  
  useEffect(() => {
    if (!certificationPeriods || !certificationPeriods.length) return;
    const currentPeriod = getCurrentPeriod(certificationPeriods)
    filters.setFieldValue('commission_id', currentPeriod.id);
  }, [certificationPeriods])

  const filters = useFormik({
    initialValues: {
      cert_year_from: '',
      cert_year_to: '',
      organization: org || '',
      commission_id: '',
      position: '',
      category: '',
      status: '',
      simple_cert: 0
    },
    enableReinitialize: true,
    validationSchema: expertFormValidation,
    validateOnMount: true,
    onSubmit: values => getRequestsList(values)
  })

  const {values, errors, touched, handleChange, handleSubmit, handleBlur} = filters

  const toggleFilters = () => {
    if (filtersVisible) {
      filters.setFieldValue('cert_date_from', '')
      filters.setFieldValue('cert_date_to', '')
      filters.setFieldValue('position', '')
      filters.setFieldValue('category', '')
      filters.setFieldValue('status', '')
    }
    setFiltersVisible(!filtersVisible)
  }
  
  useEffect(() => {
    dispatch(setReportPeriod(values.commission_id))
  }, [values.commission_id])

  return (
    <div className={styles.requestForm}>
      <h3>Заявления на аттестацию педагогических работников</h3>
      <Form onSubmit={handleSubmit}>
        <Row>
          {filtersVisible && <>
            <Form.Group className='mt-3' as={Col} md={3}>
              <Form.Label className={styles.formLabels}>Дата с:</Form.Label>
              <Form.Control
                name='cert_date_from'
                value={values.cert_date_from}
                type='date'
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={touched.cert_date_from && errors.cert_date_from}
              />
              <Form.Control.Feedback type="invalid">{errors.cert_date_from}</Form.Control.Feedback>
            </Form.Group>

            <Form.Group className='mt-3' as={Col} md={3}>
              <Form.Label className={styles.formLabels}>Дата по:</Form.Label>
              <Form.Control
                name='cert_date_to'
                value={values.cert_date_to}
                type='date'
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={touched.cert_date_to && errors.cert_date_to}
              />
              <Form.Control.Feedback type="invalid">{errors.cert_date_to}</Form.Control.Feedback>
            </Form.Group>
          </>}

          <Form.Group className='mt-3' as={Col} md={3}>
            <Form.Label className={styles.formLabels}>Период аттестации:</Form.Label>
            <Form.Select
              name='commission_id'
              value={values.commission_id}
              onChange={handleChange}
              onBlur={handleBlur}
              isInvalid={touched.commission_id && errors.commission_id}
            >
              <option value=''>Все</option>
              {getCertificationPeriodsOptions(certificationPeriods)}
            </Form.Select>
            <Form.Control.Feedback type="invalid">{errors.commission_id}</Form.Control.Feedback>
          </Form.Group>

          <Form.Group className='mt-3' as={Col} md={fullMode ? 12 : 3}>
            <Form.Label className={styles.formLabels}>Организация:</Form.Label>
            <Form.Select
              name='organization'
              value={values.organization}
              onChange={handleChange}
              onBlur={handleBlur}
              disabled={!fullMode}
              isInvalid={touched.organization && errors.organization}
            >
              <option value=''>Выбрать</option>
              {getOrganizationOptions(organizations)}
            </Form.Select>
            <Form.Control.Feedback type="invalid">{errors.organization}</Form.Control.Feedback>
          </Form.Group>
        </Row>
        
        {fullMode &&
          <Row>
            <Form.Group className='mt-3' as={Col}>
              <Form.Check
                label='аттестация педагогических работников, имеющих государственные награды, почетные звания, ведомственные знаки отличия, награды полученные за достижения в педагогической деятельности, награды конкурсов профессионального мастерства'
                name='simple_cert'
                onClick={() => filters.setFieldValue('simple_cert', values.simple_cert ? 0 : 1)}
                checked={!!values.simple_cert}
              />
            </Form.Group>
          </Row>
        }

        <Row style={{alignItems: 'end'}}>
          {filtersVisible && <>
            <Form.Group className='mt-3' as={Col} md={4}>
              <Form.Label className={styles.formLabels}>Должность:</Form.Label>
              <Form.Select
                name='position'
                value={values.position}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={touched.position && errors.position}
              >
                <option value=''>Выбрать</option>
                {getOptions(specializations)}
              </Form.Select>
              <Form.Control.Feedback type="invalid">{errors.position}</Form.Control.Feedback>
            </Form.Group>

            <Form.Group className='mt-3' as={Col} md={3}>
              <Form.Label className={styles.formLabels}>Категория:</Form.Label>
              <Form.Select
                name='category'
                value={values.category}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={touched.category && errors.category}
              >
                <option value=''>Выбрать</option>
                {getOptions(categories)}
              </Form.Select>
              <Form.Control.Feedback type="invalid">{errors.category}</Form.Control.Feedback>
            </Form.Group>

            <Form.Group className='mt-3' as={Col} md={3}>
              <Form.Label className={styles.formLabels}>Статус:</Form.Label>
              <Form.Select
                name='status'
                value={values.status}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={touched.status && errors.status}
              >
                <option value=''>Все</option>
                {getOptions(statuses)}
              </Form.Select>
              <Form.Control.Feedback type="invalid">{errors.status}</Form.Control.Feedback>
            </Form.Group>
          </>}

          <Col className='d-flex align-items-end mt-3' style={{gap: '0.5rem'}}>
            <Button label='Применить' type='submit'/>
            <Button
              label={filtersVisible ? 'Скрыть фильтры' : 'Показать фильтры'}
              type='button'
              onClick={toggleFilters}
            />
          </Col>
        </Row>
      </Form>
    </div>
  )
}
